import {
  hasCompleteQueryData,
  throwOnQueryError,
} from 'ZalamoLibrary/src/lib/core/graphql/complete-query-data';

import { Observable, filter, map, pipe, switchMap } from 'rxjs';

import { Pipe, PipeTransform } from '@angular/core';
import {
  GetPublicSessionOrganizationGQL,
  PublicSessionOrganizationType,
} from '../../../../../../photographer-panel/src/graphql';
import { OrganizationService } from 'ZalamoLibrary/src/lib/core/organizations/organization.service';

@Pipe({
  name: 'publicSessionOrganizationName',
  standalone: false,
})
export class PublicSessionOrganizationNamePipe implements PipeTransform {
  constructor(
    private getPublicSessionOrganizationGQL: GetPublicSessionOrganizationGQL,
    private organizationService: OrganizationService,
  ) {}

  transform(publicSessionOrganizationId: string): Observable<string> {
    return this.organizationService.getCurrentOrganization().pipe(
      switchMap((organizationId) =>
        this.getPublicSessionOrganizationGQL
          .watch({
            variables: {
              organizationId,
              publicSessionOrganizationType: PublicSessionOrganizationType.Any,
            },
          })
          .valueChanges.pipe(
            throwOnQueryError,
            filter(hasCompleteQueryData),
            map(
              (result) =>
                result.data['getMinePublicSessionOrganizations']['list'],
            ),
            map(
              (orgs) =>
                orgs.find(
                  (org) =>
                    org.publicSessionOrganizationId ===
                    publicSessionOrganizationId,
                )?.name,
            ),
          ),
      ),
    );
  }
}
